import {
  Box,
  Button,
  Divider,
  Typography,
  Image,
  Flex,
} from "@jewlr/storybook/core"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { Section, Text } from "@jewlr/storybook/info"
import StampedReviewsWidget from "components/stamped-reviews-widget"
import { jewlr_t } from "helpers/application"

import ReviewsChart from "./reviews-chart"

const BorderBox = styled(Box)`
  border: none;
  text-align: center;
  ${(props) => props.theme.mediaQueries.tablet`
    border-right: 1px solid  ${props.theme.colors.grey[20]};
`};
`
const SocialBox = styled(Box).attrs({
  flex: "1 1 auto",
  py: 2,
  width: "33%",
})``

const Reviews = () => {
  return (
    <Box mx={3}>
      <Box contain textAlign="left">
        <Text mb={4}>
          {jewlr_t("terms.Jewelry")} and customer experience is our passion, and
          our customers love us for it. Read what some of our customers have to
          say about us.
        </Text>
        <ReviewsChart />
      </Box>

      <Box contain mb={7} px={{ _: "10px", tablet: 2 }}>
        <StampedReviewsWidget />
      </Box>
      <Box contain mb={7}>
        <Section hasBg>
          <Typography mb={1} textAlign="center" variant="body">
            More Reviews On
          </Typography>
          <Box display={{ _: "block", tablet: "flex" }} flex="1">
            <BorderBox
              flex={{ _: 1, tablet: "1 1 auto" }}
              py={2}
              width={{ _: "100%", tablet: "33%" }}
            >
              <a
                href="https://www.shopperapproved.com/reviews/jewlr.com/"
                rel="noreferrer"
                target="_blank"
              >
                <Image
                  alt="shoppers approved"
                  ratio="2430 / 718"
                  src={require("images/info/reviews/shoppers-approved.png")}
                  width={{ _: "118px", desktop: "198px", tablet: "140px" }}
                />
              </a>
            </BorderBox>
            <Divider bg="grey.15" display={{ tablet: "none" }} width="65%" />
            <BorderBox
              flex={{ _: 1, tablet: "1 1 auto" }}
              py={2}
              width={{ _: "100%", tablet: "33%" }}
            >
              <a
                href="https://www.trustpilot.com/review/jewlr.com"
                rel="noreferrer"
                target="_blank"
              >
                <Image
                  alt="Trustpilot"
                  ratio="1133 / 278"
                  src={require("images/info/reviews/Trustpilot.svg")}
                  width={{ _: "177px", tablet: "297px" }}
                />
              </a>
            </BorderBox>
          </Box>
        </Section>
      </Box>
      <Box contain>
        <Typography mb={1} textAlign="center" variant="body">
          Stay Connected
        </Typography>
        <Flex Flex="1">
          <SocialBox>
            <Box alignItems="center" display="flex" flex="1">
              <Box flex="1 1 auto" textAlign="right" width={{ tablet: "50%" }}>
                <a
                  href="https://www.facebook.com/jewlrcom"
                  rel="noreferrer"
                  target="_blank"
                >
                  <Image
                    alt="facebook"
                    ratio="309 / 310"
                    src={require("images/icons/facebook.png")}
                    width={{ _: "34px", desktop: "66px", tablet: "46px" }}
                  />
                </a>
              </Box>
              <Box
                flex="1 1 auto"
                px={{ _: "6px", tablet: 2 }}
                textAlign="left"
                width={{ tablet: "50%" }}
              >
                <Typography
                  fontSize={{ _: "14px", tablet: "22px" }}
                  fontWeight="normal"
                  lineHeight={{ _: "1", tablet: "unset" }}
                  pt={{ _: "4px", tablet: 0 }}
                >
                  1.6M +
                </Typography>

                <Typography
                  color="neutral"
                  fontSize={{ _: "12px", tablet: "20px" }}
                  fontWeight="normal"
                >
                  Followers
                </Typography>
              </Box>
            </Box>
          </SocialBox>

          <SocialBox>
            <Box alignItems="center" display="flex" flex="1">
              <Box flex="1 1 auto" textAlign="right" width={{ tablet: "50%" }}>
                <a
                  href="https://www.instagram.com/jewlr"
                  rel="noreferrer"
                  target="_blank"
                >
                  <Image
                    alt="instagram"
                    ratio="487 / 487"
                    src={require("images/info/reviews/instagram.png")}
                    width={{ _: "34px", desktop: "66px", tablet: "46px" }}
                  />
                </a>
              </Box>
              <Box
                flex="1 1 auto"
                px={{ _: "6px", tablet: 2 }}
                textAlign="left"
                width={{ tablet: "50%" }}
              >
                <Typography
                  fontSize={{ _: "14px", tablet: "22px" }}
                  fontWeight="normal"
                  lineHeight={{ _: "1", tablet: "unset" }}
                  pt={{ _: "4px", tablet: 0 }}
                >
                  170K
                </Typography>

                <Typography
                  color="neutral"
                  fontSize={{ _: "12px", tablet: "20px" }}
                  fontWeight="normal"
                >
                  Followers
                </Typography>
              </Box>
            </Box>
          </SocialBox>
          <SocialBox>
            <Box alignItems="center" display="flex" flex="1">
              <Box flex="1 1 auto" textAlign="right" width={{ tablet: "50%" }}>
                <a
                  href="https://www.pinterest.ca/jewlrcom"
                  rel="noreferrer"
                  target="_blank"
                >
                  <Image
                    alt="pinterest"
                    ratio="487 / 487"
                    src={require("images/info/reviews/pinterest.png")}
                    width={{ _: "34px", desktop: "66px", tablet: "46px" }}
                  />
                </a>
              </Box>
              <Box
                flex="1 1 auto"
                px={{ _: "6px", tablet: 2 }}
                textAlign="left"
                width={{ tablet: "50%" }}
              >
                <Typography
                  fontSize={{ _: "14px", tablet: "22px" }}
                  fontWeight="normal"
                  lineHeight={{ _: "1", tablet: "unset" }}
                  pt={{ _: "4px", tablet: 0 }}
                >
                  20K
                </Typography>

                <Typography
                  color="neutral"
                  fontSize={{ _: "12px", tablet: "20px" }}
                  fontWeight="normal"
                >
                  Followers
                </Typography>
              </Box>
            </Box>
          </SocialBox>
        </Flex>
      </Box>
      <Divider bg="grey.20" my={6} />
      <Box contain mb={6} textAlign="center">
        <Button
          as={Link}
          data-lc="reviews"
          outline="black"
          p={{ _: "10px 26px", tablet: "16px 32px" }}
          to={`/${jewlr_t("terms.personalized")}-${jewlr_t("terms.jewelry")}`}
        >
          START {jewlr_t("terms.Personalizing").toUpperCase()}
        </Button>
      </Box>
    </Box>
  )
}

export default Reviews
